import USDTIcon from "@spheron/ui-library/dist/assets/crypto-social/Tether.svg?url";
import USDCIcon from "@spheron/ui-library/dist/assets/crypto-social/Usdc.svg?url";
import DaiIcon from "@spheron/ui-library/dist/assets/crypto-social/Dai.svg?url";
import WethIcon from "@spheron/ui-library/dist/assets/crypto-social/Weth.svg?url";
import SponIcon from "@/assets/tokens/spon.svg?url";
import UsponIcon from "@/assets/tokens/dollar.svg?url";
import {
  addressMap,
  CST,
  DAI,
  SPON,
  USDC,
  USDT,
  uSPON,
  WETH,
} from "@/contracts/addresses";

// export const SPHERON_RPC_URL = "https://spheron-devnet.rpc.caldera.xyz/http";
// export const SPHERON_RPC_URL = "https://sepolia-rollup.arbitrum.io/rpc";
// export const SPHERON_RPC_URL = "https://arbitrum-sepolia.core.chainstack.com/f89a40155b4b82dc5c601286fcac4ffb";
// export const SPHERON_TESTNET_EXPLORER_URL = "https://sepolia.arbiscan.io/";

export const SPHERON_RPC_URL =
  "https://base-sepolia.g.alchemy.com/v2/vN6ZeMQVQEjbGURcN5_vD_oVFQ_u6pQ9";

export const SPHERON_RPC_MAINNET_URL =
  "https://base-mainnet.g.alchemy.com/v2/dZHpnrcxvfBQRzfU6KEo7";

export const RPC_MAP: Record<NetworkType, string> = {
  testnet: SPHERON_RPC_URL,
  mainnet: SPHERON_RPC_MAINNET_URL,
};

export const SAMPLE_PROVIDER_ADDRESS =
  "0x6634d41cccBD1E1576Ed4c6226832521A66bF874"; // us-east provider
// export const SAMPLE_PROVIDER_ADDRESS =
//   "0x562937835cdD5C92F54B94Df658Fd3b50A68ecD5";
// export const SAMPLE_PROVIDER_ADDRESS =
//   "0x74bb7e5058Fa6FCE9928FAC9A285377E5dFD1680";

const SUBGRAPH_API_URL =
  "https://api.goldsky.com/api/public/project_cm16apa2e540c01wz70x34xzf/subgraphs/sph-base-sepolia-new/1.0.0/gn";

const SUBGRAPH_MAINNET_API_URL =
  "https://api.goldsky.com/api/public/project_cm16apa2e540c01wz70x34xzf/subgraphs/sph-base-mainnet/1.0.3/gn";

export const SUBGRAPH_MAP: Record<NetworkType, string> = {
  testnet: SUBGRAPH_API_URL,
  mainnet: SUBGRAPH_MAINNET_API_URL,
};

export const BASE_URL =
  process.env.NODE_ENV === "production"
    ? "https://provider.spheron.network"
    : "http://localhost:3010";

export const SERVICE_API_URL = "https://api-v2.spheron.network";

// Provider Node is being phased out. Point users to the Spheron GPU platform.
// UTM + referral params let us attribute traffic coming from the phase-out page.
export const SPHERON_APP_URL =
  "https://app.spheron.ai/?utm_source=provider_node&utm_medium=referral&utm_campaign=provider_node_phaseout&ref=provider_node";

export const SPHERON_SUPPORT_EMAIL = "info@spheron.network";

export interface IToken {
  id: number;
  name: string;
  symbol: string;
  decimal: number;
  address: string;
  logo: any;
}

export interface INetwork {
  chainId: number;
  chainName: string;
  rpcUrls: string[];
  nativeCurrency: {
    name: string;
    symbol: string;
    decimals: number;
  };
  blockExplorerUrls: string[];
}

export type NetworkType = "testnet" | "mainnet";

export const networkMap: Record<NetworkType, INetwork> = {
  testnet: {
    chainId: 84532,
    chainName: "Base Sepolia",
    rpcUrls: [
      "https://summer-evocative-gas.base-sepolia.quiknode.pro/a73ba0ae6a2d4c16c1729c80a243f0a00e9f5737",
    ],
    nativeCurrency: {
      name: "Sepolia Ether",
      symbol: "ETH",
      decimals: 18,
    },
    blockExplorerUrls: ["https://sepolia.basescan.org/"],
  },
  // testnet: {
  //   chainId: 89138,
  //   chainName: "Spheron Devnet",
  //   rpcUrls: ["https://spheron-devnet-eth.rpc.caldera.xyz/http"],
  //   nativeCurrency: {
  //     name: "Ethereum",
  //     symbol: "ETH",
  //     decimals: 18,
  //   },
  //   blockExplorerUrls: ["https://spheron-devnet-eth.explorer.caldera.xyz/"],
  // },
  // TODO: NEED TO UPDATE WHEN MAINNET RELEASE
  mainnet: {
    chainId: 8453,
    chainName: "Base Mainnet",
    rpcUrls: [SPHERON_RPC_MAINNET_URL],
    nativeCurrency: {
      name: "Ethereum",
      symbol: "ETH",
      decimals: 18,
    },
    blockExplorerUrls: ["https://base.blockscout.com/"],
  },
};

export const tokenMap: Record<NetworkType, IToken[]> = {
  testnet: [
    {
      id: 1,
      name: "Tether USD Test Token",
      symbol: "USDT",
      decimal: 6,
      address: USDT,
      logo: USDTIcon,
    },
    {
      id: 2,
      name: "DAI Test Token",
      symbol: "DAI",
      decimal: 18,
      address: DAI,
      logo: DaiIcon,
    },
    {
      id: 3,
      name: "Test Token USD Coin",
      symbol: "USDC",
      decimal: 6,
      address: USDC,
      logo: USDCIcon,
    },
    {
      id: 4,
      name: "Wrapped ETH Test Token",
      symbol: "WETH",
      decimal: 18,
      address: WETH,
      logo: WethIcon,
    },
    {
      id: 5,
      name: "Spheron Credit Token",
      symbol: "CST",
      decimal: 18,
      address: CST,
      logo: SponIcon,
    },
    {
      id: 6,
      name: "uSPON",
      symbol: "uSPON",
      decimal: 6,
      address: uSPON,
      logo: UsponIcon,
    },
    {
      id: 7,
      name: "SPON",
      symbol: "SPON",
      decimal: 18,
      address: SPON,
      logo: SponIcon,
    },
  ],
  mainnet: [
    {
      id: 1,
      name: "Tether USD Token",
      symbol: "USDT",
      decimal: 6,
      address: addressMap.mainnet.USDT,
      logo: USDTIcon,
    },
    {
      id: 2,
      name: "USD Coin",
      symbol: "USDC",
      decimal: 6,
      address: addressMap.mainnet.USDC,
      logo: USDCIcon,
    },
    {
      id: 3,
      name: "uSPON",
      symbol: "uSPON",
      decimal: 6,
      address: addressMap.mainnet.uSPON,
      logo: UsponIcon,
    },
    {
      id: 4,
      name: "SPON",
      symbol: "SPON",
      decimal: 18,
      address: addressMap.mainnet.SPON,
      logo: SponIcon,
    },
  ],
};

export const paymentsAccepted: Record<NetworkType, string[]> = {
  testnet: [addressMap.testnet.uSPON, addressMap.testnet.SPON],
  mainnet: [addressMap.mainnet.uSPON, addressMap.mainnet.SPON],
}

export const networkType =
  (process.env.NEXT_PUBLIC_NETWORK_TYPE as string) || "mainnet";

export const IS_WITHDRAW_DISABLED: boolean =
  process.env.NEXT_PUBLIC_IS_DISABLED === "true";
